( function( $ ) {
$(document).ready(function(){

		var menuOpen = 'no';
		var menuSelector = '.mob-menu-panel';

		function openMenu(){
			if(menuOpen === 'no') {
				$(menuSelector).addClass('navOpen');
				menuOpen = 'yes';
				$('.menu-icon').addClass('open');

			 } else

			 if(menuOpen === 'yes') {
				$(menuSelector).removeClass('navOpen');
				menuOpen = 'no';
				$('.menu-icon').removeClass('open');
			 }
		}


		$('.menu-icon').click(function() {
			 openMenu();
		});



		$('.product-desc-spec a[href*=".pdf"], .product-desc-spec a.datasheet-download').click(function(){
    	window.open(this.href);
    	return false;
  	});


	////////////////////////////////////////////////////////////////////////////////

	// Home Top Slider

	$('.home-top-slider').slick({
		// autoplay: true,
		autoplay:$('.home-top-slider').data('autoplay'),
  		// autoplaySpeed: 5000,
  		autoplaySpeed: $('.home-top-slider').data('speed'),

		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		useTransform: true,
		cssEase:'ease',
		arrows:false,
		dots:true,
		fade: true,
		adaptiveHeight: false,
		responsive: [
	    {
	      breakpoint: 1200,
	      settings: {
	        slidesToShow: 1,
	        infinite: true,
	      }
	    },
	    {
	      breakpoint: 600,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 480,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    // You can unslick at a given breakpoint now by adding:
	    // settings: "unslick"
	    // instead of a settings object
	  ]
	});



	// $('.home-top-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
	//   console.log('changed')

	// });




////////////////////////////////////////////////////////////////////////////////


// var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

// if (isMobile) {

//   console.log('Hi, im mobile!');
// }

// var isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

//  var imgLg =  document.querySelector(".img-lg");
//  var imgSm =  document.querySelector(".img-sm");

//  if (isMobile) {
//    imgSm.style.display = "block"

//  } else {
//    imgLg.style.display = "block"
//  }




// END DOC READY
});




} )( jQuery );